export const CLONE_WARNING_MESSAGE = {
  NOT_CLONE_WORKFLOWS_AND_GDPR: 'NOT_CLONE_WORKFLOWS_AND_GDPR',
  NOT_CLONE_WORKFLOWS: 'NOT_CLONE_WORKFLOWS',
  NOT_CLONE_GDPR: 'NOT_CLONE_GDPR'
};
export const CLONE_VALIDATION_ERRORS = {
  FORM_NAME_TOO_LONG: 'FORM_NAME_TOO_LONG'
};